<template>
<!-- eslint-disable-next-line vue/no-unused-vars -->
  <v-hover v-slot:default="{ hover }">
    <div v-ripple class="d-flex blue5 elevation-2 py-1" style="border-radius:3px" @click="doNavigation">
      <div class="px-2" style="display: inline-block;">
        <div v-if="driverName">{{ driverName }}</div>
        <div class="subtitle-2 text--secondary">
          <div v-if="isOperator && driver.relationship">
            <span>Relationship: {{ driver.relationship }}</span>
          </div>
          <div v-else-if="displayCompanyDriverNumber">
            <span>Company Driver #: {{ driver.companyDriverNumber ? driver.companyDriverNumber : '' }}</span>
          </div>
          <div v-else>
            <pre>&nbsp;</pre>
          </div>
        </div>
      </div>
      <template v-if="driver.dateOfBirth">
        <v-spacer />
        <div class="px-2 text-center date-of-birth">
          <v-icon>mdi-cake-variant</v-icon>
          <div v-if="driver.dateOfBirth" class="subtitle-2 text--secondary">{{ formatDate(driver.dateOfBirth) }}</div>
        </div>
      </template>
    </div>
  </v-hover>
</template>

<style scoped>
.date-of-birth {
  width: 75px;
}
</style>

<script>
import displayFormatterService from '@/services/shared/displayFormatterService.js';
import analyticsService from '@/services/shared/analyticsService.js';
import { mapState } from 'vuex';

export default {
  name: 'DriverSummary',
  props: {
    driver: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      hover: false
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    driverName () {
      return this.driver.firstName + ' ' + this.driver.lastName + ' ' + this.driver.suffix;
    },
    displayCompanyDriverNumber () {
      // AUTOB
      return this.selectedLineOfBusinessCode === 9 && this.driver.companyDriverNumber !== 0;
    },
    isOperator () {
      return this.driver.type === 1;
    },
    displayDriverNumberAndDob () {
      return this.driver.dateOfBirth && this.displayCompanyDriverNumber;
    }
  },
  methods: {
    doNavigation () {
      if ((this.driver || null) === null) return;
      if (this.isOperator) {
        analyticsService.sendEvent(this.$gtag, 'Button Click', 'Policy', 'Boat Operator');
      } else {
        analyticsService.sendEvent(this.$gtag, 'Button Click', 'Policy', 'Auto Drivers Driver');
      }
      var newPath = `${this.$route.path}/driver/${this.driver.id}`;
      this.$router.push(newPath);
    },
    formatDate: function (dateToFormat) {
      return displayFormatterService.formatDayMonthDate(dateToFormat);
    }
  }
};
</script>
